import React, { memo, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FaTrash as DeleteIcon } from 'react-icons/fa';
import {
  MdKeyboardArrowLeft as ArrowLeftIcon,
  MdClear as ExitIcon,
} from 'react-icons/md';

import AddContentButton from '../../addContentButton.component';
import ContentButton from '../../contentButton.component';

import Spinner from '../../../../shared/spinner.component';
import { fetchReleaseNotes } from './store/actions';
import { deleteHelpContent, createHelpContent } from '../../../shared/store/actions';
import { helpContentDeletingSelector, helpAddingSelector } from '../../../shared/store/selectors';
import {
  isLoadingSelector,
  releaseNotesSelector,
} from './store/selectors';

import { RELEASE_NOTES_NAME, SEARCH_DOCUMENTATION_SECTION_NAME } from '../../helpMenu.constants';
import { ALL_CLIENTS } from '../../../shared/constants';

const DeleteIconWithSpinner = ({ loading, onClick }) => loading
  ? <Spinner className="ContentButton-deletingIcon" small />
  : <DeleteIcon
    className="ContentButton-deleteIcon"
    onClick={onClick}
  />;

DeleteIconWithSpinner.propTypes = {
  loading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

const ReleaseNotes = ({
  fetchReleaseNotes,
  releaseNotes,
  isLoading,
  createHelpContent,
  addingReleaseNote,
  deleteHelpContent,
  deletingReleaseNote,
  history,
  onClose,
  contentEditable,
}) => {
  useEffect(() => {
    fetchReleaseNotes();
  }, [fetchReleaseNotes]);

  function handleCreateHelpContent({ title }) {
    return createHelpContent({ title, settings: { clients: [ALL_CLIENTS] }, sectionName: RELEASE_NOTES_NAME });
  }

  function deleteReleaseNote(releaseNoteId) {
    return event => {
      event.stopPropagation();
      deleteHelpContent(releaseNoteId);
    };
  }

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <>
      <h4 className="popup-header">
        <div className="header">
          <div className="popup-header-back-arrow" onClick={history.goBack}>
            <ArrowLeftIcon />
          </div>
          <h5>{SEARCH_DOCUMENTATION_SECTION_NAME}</h5>
          <ExitIcon onClick={onClose} className="popup-header-exit" />
        </div>
      </h4>
      <div className="popup-body">
        <div>
          {
            contentEditable
              ? <AddContentButton onSubmit={handleCreateHelpContent} loading={addingReleaseNote} /> // eslint-disable-line react/jsx-no-bind
              : null
          }
          {releaseNotes.map(releaseNote => (
            <ContentButton
              key={releaseNote.title}
              to={`/content/${releaseNote.contentId}`}
              rightIcon={!contentEditable
                ? null
                : <DeleteIconWithSpinner
                  loading={deletingReleaseNote === releaseNote.contentId}
                  onClick={deleteReleaseNote(releaseNote.contentId)}
                />
              }
            >
              {releaseNote.title}
            </ContentButton>
          ))}
        </div>
      </div>
    </>
  );
};

ReleaseNotes.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  addingReleaseNote: PropTypes.bool.isRequired,
  deletingReleaseNote: PropTypes.bool.isRequired,
  createHelpContent: PropTypes.func.isRequired,
  fetchReleaseNotes: PropTypes.func.isRequired,
  deleteHelpContent: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  releaseNotes: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    section: PropTypes.string.isRequired,
    contentId: PropTypes.number.isRequired,
  })).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  contentEditable: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    isLoading: isLoadingSelector(state),
    releaseNotes: releaseNotesSelector(state),
    addingReleaseNote: helpAddingSelector(state),
    deletingReleaseNote: helpContentDeletingSelector(state),
  };
}

export default memo(connect(
  mapStateToProps,
  {
    fetchReleaseNotes,
    createHelpContent,
    deleteHelpContent,
  }
)(ReleaseNotes));
